import {
  GetArchTypes,
  GetPurposeTypes
} from '@api'

export const editForm = async function () {
  const archTypes = (await GetArchTypes({})).data || []
  const purposeTypes = (await GetPurposeTypes({})).data || []
  let result = [
    {
      key: 'ArchiveQueryType',
      type: 'select',
      label: '查档单位类型',
      width: '50%',
      options: archTypes.map(m => ({
        value: m.KEY_1_VALUE,
        text: m.DATA_1_VALUE
      })),
      rules: {
        required: true,
        message: '必须选择类型',
        trigger: 'change'
      }
    }, {
      key: 'CompanyName',
      type: 'input',
      label: '查档人单位',
      width: '50%',
      rules: {
        required: true,
        message: '必须输入查档人单位',
        trigger: 'blur'
      }
    }, {
      key: 'UserName',
      type: 'input',
      label: '查档人姓名',
      width: '50%',
      readonly: true,
      rules: {
        required: true,
        message: '必须输入查档人姓名',
        trigger: 'blur'
      }
    }, {
      key: 'CardNo',
      type: 'input',
      label: '身份证号',
      width: '50%',
      readonly: true,
      rules: {
        required: true,
        message: '必须输入身份证号',
        trigger: 'blur'
      }
    }, {
      key: 'Phone',
      type: 'input',
      label: '移动电话',
      width: '50%',
      rules: [
        {
          required: true,
          message: '必须输入移动电话',
          trigger: 'blur'
        }, {
          pattern: /^[1]([3-9])[0-9]{9}$/,
          message: '请输入正确的格式',
          trigger: 'blur'
        }
      ]
    }, {
      key: 'EMail',
      type: 'input',
      label: '邮箱',
      width: '50%',
      rules: [
        {
          required: true,
          message: '必须输入邮箱',
          trigger: 'blur'
        }, {
          type: 'email',
          message: '请输入正确的格式',
          trigger: 'blur'
        }
      ]
    }, {
      type: 'appointmentDate',
      label: '预约日期',
      date: {
        key: 'SubscribeZQDate',
        options: {
          disabledDate: date => {
            return Date.parse(date) < Date.parse(new Date())
          }
        }
      },
      select: {
        key: 'Amorpm',
        options: [
          {
            value: 1,
            text: this.$config.registerDateTo[0]
          }, {
            value: 2,
            text: this.$config.registerDateTo[1]
          }
        ]
      }
    }, {
      key: 'ArchiveIDS',
      type: 'ul',
      label: '查档工程',
      options: [],
      noReset: true,
      tips: '无数据，需到查档申请页面申请文件'
    }, {
      key: 'QueryContent',
      type: 'ul',
      label: '查档内容',
      options: [],
      noReset: true,
      tips: '无数据，需到查档申请页面申请文件'
    }, {
      key: 'QueryPurpose',
      type: 'select',
      label: '查档目的',
      options: purposeTypes.map(m => ({
        value: m.KEY_1_VALUE,
        text: m.DATA_1_VALUE
      })),
      rules: {
        required: true,
        message: '必须选择查档目的',
        trigger: 'change'
      }
    }, {
      key: 'Remark',
      type: 'input',
      inputType: 'textarea',
      autosize: {
        minRows: 2
      },
      label: '补充说明',
      maxlength: 500,
      showWordLimit: true
    }
  ]
  const { item, engItems } = this
  result.map(m => {
    const { key, type } = m
    if (item.SID) {
      if (type === 'appointmentDate') {
        m.date.value = new Date(item.SubscribeZQDate)
        m.select.value = item.Amorpm
      } else if (key === 'QueryContent') {
        const fileIDS = (item.FileIDS || '').split(',')
        m.options = (item.QueryContent || '').split('|').map((m, index) => ({
          value: fileIDS[index],
          text: m
        }))
        m.value = m.options.map(m => ({
          SID: m.value,
          FILE_TITLE: m.text
        }))
      } else if (key === 'ArchiveIDS') {
        m.options = engItems.map(p => ({
          value: p.SID,
          text: p.ENG_NAME
        }))
        m.value = engItems.map(m => m.SID).join(',')
      } else {
        m.value = item[m.key]
      }
    } else {
      // 预设值
      const { userName, userID } = this.$store.state.user
      if (key === 'UserName') {
        m.value = userName
      } else if (key === 'CardNo') {
        m.value = userID
      } else if (type === 'appointmentDate') {
        m.date.value = new Date(Number(new Date()) + 1 * 24 * 60 * 60 * 1000)
        m.select.value = 1
      }
    }
  })
  if (item.CDType === 2) {
    // 1 预约登记 2 在线登记
    const index = result.findIndex(f => f.type === 'appointmentDate')
    result.splice(index, 1)
  }
  return result
}